import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const PaymentSection = ({ paymentSettings, onUpdate }) => {
  const [activeTab, setActiveTab] = useState('crypto');
  const [cryptoWallet, setCryptoWallet] = useState(paymentSettings?.cryptoWallet || '');
  const [cardNumber, setCardNumber] = useState(paymentSettings?.cardNumber || '');
  const [selectedCurrency, setSelectedCurrency] = useState(paymentSettings?.currency || 'btc');

  const cryptoCurrencies = [
    { value: 'btc', label: 'Bitcoin (BTC)', description: 'Основная криптовалюта' },
    { value: 'eth', label: 'Ethereum (ETH)', description: 'Смарт-контракты' },
    { value: 'usdt', label: 'Tether (USDT)', description: 'Стабильная монета' },
    { value: 'ton', label: 'Toncoin (TON)', description: 'Telegram криптовалюта' }
  ];

  const mockTransactions = [
    {
      id: 1,
      type: 'received',
      amount: '0.0025 BTC',
      amountRub: '₽12,500',
      from: 'Анонимный слушатель',
      date: '04.12.2025',
      status: 'completed'
    },
    {
      id: 2,
      type: 'received',
      amount: '0.05 ETH',
      amountRub: '₽8,750',
      from: 'Философия Присутствия',
      date: '03.12.2025',
      status: 'completed'
    },
    {
      id: 3,
      type: 'received',
      amount: '50 USDT',
      amountRub: '₽5,000',
      from: 'Звуки Острова',
      date: '01.12.2025',
      status: 'pending'
    }
  ];

  const handleSaveCrypto = () => {
    onUpdate({
      cryptoWallet,
      currency: selectedCurrency
    });
  };

  const handleSaveCard = () => {
    onUpdate({
      cardNumber
    });
  };

  return (
    <div className="payment-section bg-card rounded-lg p-6 shadow-soft">
      <div className="section-header flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Wallet" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Платежи и донаты
          </h2>
          <p className="text-sm text-muted-foreground">
            Настройка способов получения пожертвований
          </p>
        </div>
      </div>
      <div className="payment-tabs mb-6">
        <div className="flex gap-2 p-1 bg-muted rounded-lg">
          <button
            onClick={() => setActiveTab('crypto')}
            className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
              activeTab === 'crypto' ?'bg-background text-foreground shadow-soft' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            Криптовалюта
          </button>
          <button
            onClick={() => setActiveTab('card')}
            className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
              activeTab === 'card' ?'bg-background text-foreground shadow-soft' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            Банковская карта
          </button>
          <button
            onClick={() => setActiveTab('history')}
            className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
              activeTab === 'history' ?'bg-background text-foreground shadow-soft' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            История
          </button>
        </div>
      </div>
      {activeTab === 'crypto' && (
        <div className="crypto-settings space-y-6">
          <Select
            label="Криптовалюта"
            description="Выберите предпочитаемую криптовалюту для донатов"
            options={cryptoCurrencies}
            value={selectedCurrency}
            onChange={setSelectedCurrency}
          />

          <Input
            label="Адрес кошелька"
            type="text"
            placeholder="Введите адрес вашего криптокошелька"
            value={cryptoWallet}
            onChange={(e) => setCryptoWallet(e?.target?.value)}
            description="Убедитесь, что адрес указан правильно"
          />

          <div className="crypto-info p-4 bg-accent/10 rounded-lg border border-accent/20">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-accent)" />
              <div>
                <h4 className="text-sm font-medium text-foreground mb-1">
                  Безопасность криптовалютных транзакций
                </h4>
                <p className="text-xs text-muted-foreground">
                  Все криптовалютные транзакции необратимы. Тщательно проверяйте адрес кошелька перед сохранением. Мы не храним ваши приватные ключи.
                </p>
              </div>
            </div>
          </div>

          <div className="form-actions flex items-center gap-3 pt-6 border-t border-border">
            <Button
              variant="default"
              onClick={handleSaveCrypto}
              iconName="Check"
              iconPosition="left"
            >
              Сохранить настройки
            </Button>
          </div>
        </div>
      )}
      {activeTab === 'card' && (
        <div className="card-settings space-y-6">
          <Input
            label="Номер карты"
            type="text"
            placeholder="0000 0000 0000 0000"
            value={cardNumber}
            onChange={(e) => setCardNumber(e?.target?.value)}
            description="Карта для получения донатов в рублях"
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input
              label="Срок действия"
              type="text"
              placeholder="ММ/ГГ"
            />
            <Input
              label="Имя держателя"
              type="text"
              placeholder="Как на карте"
            />
          </div>

          <div className="card-info p-4 bg-warning/10 rounded-lg border border-warning/20">
            <div className="flex items-start gap-3">
              <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
              <div>
                <h4 className="text-sm font-medium text-foreground mb-1">
                  Комиссия за переводы
                </h4>
                <p className="text-xs text-muted-foreground">
                  При получении донатов на банковскую карту взимается комиссия 3%. Минимальная сумма вывода - ₽500.
                </p>
              </div>
            </div>
          </div>

          <div className="form-actions flex items-center gap-3 pt-6 border-t border-border">
            <Button
              variant="default"
              onClick={handleSaveCard}
              iconName="Check"
              iconPosition="left"
            >
              Сохранить карту
            </Button>
          </div>
        </div>
      )}
      {activeTab === 'history' && (
        <div className="transaction-history">
          <div className="history-stats mb-6 grid grid-cols-2 sm:grid-cols-3 gap-4">
            <div className="stat-card p-4 bg-muted/50 rounded-lg">
              <div className="flex items-center gap-2 mb-1">
                <Icon name="TrendingUp" size={16} color="var(--color-success)" />
                <span className="text-xs text-muted-foreground">Всего получено</span>
              </div>
              <p className="text-xl font-heading font-semibold text-foreground">
                ₽26,250
              </p>
            </div>
            <div className="stat-card p-4 bg-muted/50 rounded-lg">
              <div className="flex items-center gap-2 mb-1">
                <Icon name="Clock" size={16} color="var(--color-warning)" />
                <span className="text-xs text-muted-foreground">В обработке</span>
              </div>
              <p className="text-xl font-heading font-semibold text-foreground">
                ₽5,000
              </p>
            </div>
            <div className="stat-card p-4 bg-muted/50 rounded-lg col-span-2 sm:col-span-1">
              <div className="flex items-center gap-2 mb-1">
                <Icon name="Users" size={16} color="var(--color-primary)" />
                <span className="text-xs text-muted-foreground">Донатеров</span>
              </div>
              <p className="text-xl font-heading font-semibold text-foreground">
                3
              </p>
            </div>
          </div>

          <div className="transaction-list space-y-3">
            {mockTransactions?.map((transaction) => (
              <div
                key={transaction?.id}
                className="transaction-item p-4 bg-background rounded-lg border border-border"
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      transaction?.status === 'completed' 
                        ? 'bg-success/10' :'bg-warning/10'
                    }`}>
                      <Icon
                        name={transaction?.status === 'completed' ? 'CheckCircle' : 'Clock'}
                        size={20}
                        color={transaction?.status === 'completed' 
                          ? 'var(--color-success)' :'var(--color-warning)'}
                      />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground">
                        {transaction?.from}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {transaction?.date}
                      </p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-semibold text-foreground">
                      {transaction?.amount}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {transaction?.amountRub}
                    </p>
                  </div>
                </div>
                <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs ${
                  transaction?.status === 'completed'
                    ? 'bg-success/10 text-success' :'bg-warning/10 text-warning'
                }`}>
                  {transaction?.status === 'completed' ? 'Завершено' : 'В обработке'}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentSection;